<template>
    <div class="eda-login">

        <h1 class="eda-login__heading">
            {{ $t('login.heading') }}
        </h1>

        <form @submit.prevent="login"
              class="eda-login__form">

            <div class="eda-login__username">
                <v-input
                        v-model="loginName"
                        :darkTheme="true"
                        :keep-label="false"
                        :label="$t('login.email.label')"
                        name="username"
                        type="text"
                />
            </div>

            <div class="eda-login__password">
                <v-input
                        v-model="password"
                        :keep-label="false"
                        :darkTheme="true"
                        :label="$t('login.password.label')"
                        name="password"
                        type="password"
                />

            </div>

            <div class="eda-login__recover">
                <div class="eda-login__recover-link">

                    <eda-link to="/user/recover">
                        {{ $t('login.forgotPassword') }}
                    </eda-link>
                </div>
            </div>

            <div class="eda-login__submit" :class="{'eda-login__submit--error': error}">
                <eda-button
                        :error="error"
                        type="submit"
                        :loading="loading"
                        :label="$t('login.submit')"
                        class="eda-login__button">
                </eda-button>
            </div>
        </form>

        <div class="eda-login__new">
            {{ $t('login.newUser') }}
            <span class="eda-login__new-link">

            <eda-link to="/user/new">
                {{ $t('login.createUser') }}
            </eda-link>
            </span>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import EdaButton from "../components/vButton"
  import EdaLink from "../components/vLink"
  import api from "../mixins/apiMixin.js"
  import vInput from "../components/vInput"
  import EdaEllipsisLoader from "../components/vEllipsisLoader"
  import { mapActions } from 'vuex';

  export default {
    name: "eda-login",
    components: {
      EdaButton,
      EdaLink,
      vInput,
      EdaEllipsisLoader,
    },
    data: function () {
      return {
        loading: false,
        loginName: "",
        password: "",
        error: false,
      }
    },
    mixins: [
      api.apiMixin
    ],
    methods: {
      ...mapActions([
        "setUser"
      ]),
      login() {

        var that = this;
        that.error = false;
        that.loading = true;
        let config = that.apiHeaders;
        axios.post("api/users/login", {
          "loginName": that.loginName,
          "password": that.password
        }, config).then(function (response) {
          that.setUser(response.data);
          //       axios.defaults.headers.common['Authorization'] = "Bearer " + response.data.token;
          that.$router.push({ path: '/cars' });
        }).catch(function (error) {
          that.error = true;
        }).finally(function () {
          that.loading = false;
        });
      }
    }
  }

</script>

<style lang="scss">

    .eda-login__heading {
        font-weight: 600;
        opacity: 0;
    }

    .eda-login {

        padding-top: 4vw;
        font-size: 1.1em;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: white;

        &__form {
            display: block;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }

    .eda-login__password,
    .eda-login__username,
    .eda-login__submit {

        padding: 0 0.5em;
        max-width: 25em;
        width: 100%;
    }

    .eda-login__submit {
        padding: 0.5em;
        display: flex;
        justify-content: center;
        padding-bottom: 1em;
    }

    .eda-login__submit--error {
        animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    .eda-login__button {
        text-align: center;
        color: white;
        position: relative;
        background-color: #00B27C;
        overflow: hidden;
    }

    .eda-login__loader {
        z-index: 0;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        position: absolute;
    }

    .eda-login__loader,
    .eda-login__button-label {
        transition: all 0.2s ease;
    }

    .eda-login__loader--hidden {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.2);
    }

    .eda-login__button-label--hidden {
        opacity: 0;
        transform: translateY(0em) scale(0.2);
    }

    .eda-login__recover {
        width: 100%;
        max-width: 25em;
        padding: 1em 2em 2em 1.5em;
        text-align: left;
    }

    .eda-login__recover-link {
        font-size: 0.8em;
    }

    .eda-login__forgot {
        font-size: 0.8em;
    }

    .eda-login__new {
        padding-top: 2em;
        font-size: 0.8em;
    }

    .eda-login__new-link {
        padding-left: 0.5em;
    }

    .eda-login__link {
        color: #00B27C;
        font-weight: 300;
    }


</style>